/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {CreditItem, PackagesItemsPerson} from "types/entities/PackagesItems";
import {PackageCategory} from "types/enums/PackageCategory";
import {PackageItemPersonType} from "types/enums/PackageItemPersonType";
import {currencyNumberFormat} from "utils/utility";

interface BookingPackagesCreditsPriceDisplayProps {
    category?: PackageCategory | null;
    personType: PackageItemPersonType;
    i: number;
    selectedPackageItem: PackagesItemsPerson | null;
    selectedPackageCreditItem: CreditItem | null;
}

const BookingPackagesCreditsPriceDisplay = ({
    category,
    personType,
    i,
    selectedPackageItem,
    selectedPackageCreditItem,
}: BookingPackagesCreditsPriceDisplayProps) => {
    
    const getPrice = () => {
        if (category === PackageCategory.FerienPass && personType === PackageItemPersonType.Adult && i === 0) {
            return 0;
        }
        
        if (selectedPackageItem?.price || selectedPackageCreditItem?.price) {
            return (selectedPackageItem?.price || 0) + (selectedPackageCreditItem?.price || 0);
        }
        
        return null;
    };

    const price = getPrice();

    return (
        <div className={"flex flex-row items-center justify-end xl:justify-center font-bold text-black text-sm xl:text-base"}>
            {price !== null ? (
                <span>{currencyNumberFormat(price)}</span>
            ) : (
                <span>---</span>
            )}
        </div>
    );
};

export default BookingPackagesCreditsPriceDisplay;
